"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpectatorOverview = exports.getCurrentPlayerIndex = void 0;
var vue_1 = require("vue");
var PlayerInfo_1 = require("./PlayerInfo");
var OverviewSettings_1 = require("./OverviewSettings");
var OtherPlayer_1 = require("../OtherPlayer");
var ActionLabel_1 = require("./ActionLabel");
var Phase_1 = require("../../Phase");
var SHOW_NEXT_LABEL_MIN = 2;
var getCurrentPlayerIndex = function (player, players) {
    var currentPlayerIndex = 0;
    players.forEach(function (p, index) {
        if (p.color === player.color) {
            currentPlayerIndex = index;
        }
    });
    return currentPlayerIndex;
};
exports.getCurrentPlayerIndex = getCurrentPlayerIndex;
exports.SpectatorOverview = vue_1.default.component('spectator-overview', {
    props: {
        player: {
            type: Object,
        },
    },
    components: {
        'player-info': PlayerInfo_1.PlayerInfo,
        'overview-settings': OverviewSettings_1.OverviewSettings,
        'other-player': OtherPlayer_1.OtherPlayer,
    },
    data: function () {
        return {};
    },
    methods: {
        hasPlayers: function () {
            return this.player.players.length > 0;
        },
        getPlayerOnFocus: function () {
            var _this = this;
            return this.player.players.filter(function (p) { return p.color === _this.player.color; })[0];
        },
        getIsFirstForGen: function (player) {
            return exports.getCurrentPlayerIndex(player, this.player.players) === 0;
        },
        getPlayersInOrder: function () {
            return this.player.players;
        },
        getActionLabel: function (player) {
            var _this = this;
            if (this.player.game.phase === Phase_1.Phase.DRAFTING) {
                if (player.needsToDraft) {
                    return ActionLabel_1.ActionLabel.DRAFTING;
                }
                else {
                    return ActionLabel_1.ActionLabel.NONE;
                }
            }
            else if (this.player.game.phase === Phase_1.Phase.RESEARCH) {
                if (player.needsToResearch) {
                    return ActionLabel_1.ActionLabel.RESEARCHING;
                }
                else {
                    return ActionLabel_1.ActionLabel.NONE;
                }
            }
            if (this.player.game.passedPlayers.includes(player.color)) {
                return ActionLabel_1.ActionLabel.PASSED;
            }
            if (player.isActive)
                return ActionLabel_1.ActionLabel.ACTIVE;
            var notPassedPlayers = this.player.players.filter(function (p) { return !_this.player.game.passedPlayers.includes(p.color); });
            var currentPlayerIndex = exports.getCurrentPlayerIndex(player, notPassedPlayers);
            var prevPlayerIndex = currentPlayerIndex === 0 ?
                notPassedPlayers.length - 1 :
                currentPlayerIndex - 1;
            var isNext = notPassedPlayers[prevPlayerIndex].isActive;
            if (isNext && this.player.players.length > SHOW_NEXT_LABEL_MIN) {
                return ActionLabel_1.ActionLabel.NEXT;
            }
            return ActionLabel_1.ActionLabel.NONE;
        },
    },
    template: "\n        <div class=\"players-overview\" v-if=\"hasPlayers()\">\n            <player-info v-for=\"(p, index) in getPlayersInOrder()\" :activePlayer=\"player\" :player=\"p\"  :key=\"p.id\" :firstForGen=\"getIsFirstForGen(p)\" :actionLabel=\"getActionLabel(p)\" :playerIndex=\"index\"/>\n        </div>\n    ",
});
//# sourceMappingURL=SpectatorOverview.js.map